// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// create modules to be extended in individual files
angular.module('summonApp.factories', [])
angular.module('summonApp.factories.configs', [])
angular.module('summonApp.factories.scrolls', [])
angular.module('summonApp.services', ['summonApp.factories.configs', 'summonApp.factories.scrolls'])
angular.module('summonApp.controllers', [])
angular.module('summonApp.directives', [])
angular.module('summonApp.constants', [])
angular.module('summonApp.values', [])
angular.module('summonApp.resultsFeedPlugins', [])
angular.module('summonApp.animations', [])
angular.module('summonApp.filters', [])
angular.module('summonApp.urlRewriter', [])
angular.module('summonApp.syndetics', [])
angular.module('summonApp.custom', [])
